import React from "react";
import { Box, Flex, Image, Text, Spinner } from "@chakra-ui/react";
import {
  newBorder,
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
  whiteAlt,
} from "../../../../../utils/colors";

const PatientPortalClinicInfo = ({ loading, patientPortalPublicDetails }) => {
  console.log("patientPortalPublicDetails: ", patientPortalPublicDetails);

  return (
    <>
      {patientPortalPublicDetails ? (
        <>
          {/* CLINIC INFO */}
          <Flex align="center">
            {patientPortalPublicDetails && patientPortalPublicDetails.logo && (
              <Flex
                align="center"
                justify="center"
                h="42px"
                w="42px"
                borderRadius="50%"
                overflow="hidden"
                border={`1px solid ${newBorder}`}
                m="0 0.5rem 0.5rem 0"
                flexShrink={0}
              >
                <Image
                  w="100%"
                  h="100%"
                  objectFit="cover"
                  src={patientPortalPublicDetails.logo}
                />
              </Flex>
            )}
            {patientPortalPublicDetails &&
              patientPortalPublicDetails.clinicName && (
                <Text
                  fontSize={["sm", "1.125rem"]}
                  fontWeight="600"
                  color={textPrimary}
                >
                  {patientPortalPublicDetails.clinicName}
                </Text>
              )}
          </Flex>
          <Box>
            {patientPortalPublicDetails &&
              patientPortalPublicDetails.address?.street &&
              patientPortalPublicDetails.address?.city &&
              patientPortalPublicDetails.address?.zip &&
              patientPortalPublicDetails.address?.country && (
                <Text fontSize="sm" color={textSecondary}>
                  {patientPortalPublicDetails.address?.street},{" "}
                  {patientPortalPublicDetails.address?.city},{" "}
                  {patientPortalPublicDetails.address?.zip},{" "}
                  {patientPortalPublicDetails.address?.country}
                </Text>
              )}
            {patientPortalPublicDetails &&
              patientPortalPublicDetails.supportEmail && (
                <Text fontSize="sm" color={textSecondary}>
                  {patientPortalPublicDetails.supportEmail}
                </Text>
              )}
            {patientPortalPublicDetails &&
              patientPortalPublicDetails.phone &&
              patientPortalPublicDetails.phone.length > 4 && (
                <Text fontSize="sm" color={textSecondary}>
                  {patientPortalPublicDetails.phone}
                </Text>
              )}
          </Box>
        </>
      ) : (
        <Flex>
          <Spinner size="md" color={primaryAlt} />
        </Flex>
      )}
    </>
  );
};

export default PatientPortalClinicInfo;
